<template>
  <kye-drawer :visible.sync="visible"
           size="508px"
           :modal="false"
           :withHeader="false"
           :direction="'rtl'"
           class="ams-notice-drawer"
           :appendToBody="false"
           :wrapperClosable="true" @close="handleClose">
    <DrawerHeader
        :title="`重要通知(${noticeList.length})`"
        @close="visible = false"  />
    <div class="notice-drawer-content">
      <el-form :model.sync="form" ref="form" :noErrorPop="true" :inline="true" class="search-form">
        <el-form-item label="发布时间" prop="publishDates" >
          <kye-date-picker
            style="min-width: 165px;"
            v-model="form.publishDates"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :default-time="['00:00:00', '23:59:59']"
            >
          </kye-date-picker>
        </el-form-item>
        <el-form-item label="标题" prop="noticeTitle">
          <el-input v-model="form.noticeTitle" clearable style="width: 110px"/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="list-item-wrapper kye-scrollbar" v-if="noticeList.length">
        <div class="list-item" v-for="item in noticeList" :key="item.id" @click="goNoticeDetail(item)">
          <div class="list-item-element">
            <div class="list-item-status" :class="{'expires': item.status !== 1}">
              <span>{{ item.status === 1 ? '进行中' : '已过期' }}</span>
            </div>
            <div class="list-item-content-wrapper">
              <div class="list-item-content">
                {{item.noticeTitle}}
              </div>
              <div class="list-item-time">{{date(item.publishDate)}}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="empty-box">
        <img src="./images/no-notice.svg" alt="">
        <div class="empty-text">暂无通知</div>
      </div>
    </div>
  </kye-drawer>
</template>

<script>
  import DrawerHeader from '../drawer/drawer-header.vue'
  import { date } from 'public/utils/filter.js'
  import moment from 'moment'

  export default {
    components: {
      DrawerHeader
    },
    props: {
      params: Object
    },
    data () {
      return {
        visible: false,
        noticeList: [],
        form: {
          publishDates: [],
          noticeTitle: ''
        }
      }
    },
    methods: {
      date,
      handleSearch () {
        this.getNoticeList()
      },
      // 获取通知列表
      async getNoticeList () {
        let date = this.form.publishDates
        const start = date[0] ? moment(date[0]).format('YYYY-MM-DD 00:00:00') : ''
        const end = date[1] ? moment(date[1]).format('YYYY-MM-DD 23:59:59') : ''
        const params = {
          noticeTitle: this.form.noticeTitle,
          publishDates: [start, end]
        }
        const res = await this.$http('system.homeIndexNotice.searchUserNotice', {...params}, {appkey: '10124'})
        this.noticeList = res
      },
      goNoticeDetail (row) {
        window.erpOpen(row.relationLink, '_blank')
      },
      async openDrawer (noticeList) {
        this.visible = true
        this.noticeList = noticeList
      },
      handleClose () {
        this.visible = false
        this.$emit('close')
      },
    }
  }
</script>

<style lang="less" scoped>
.ams-notice-drawer {
  top: 78px !important;
  .empty-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    img {
      display: block;
      width: 155px;
      height: 100px;
    }
    .empty-text {
      color: #999999;
      font-size: 12px;
    }
  }
  .notice-drawer-content {
    padding: 10px 0px;
    height: calc(100vh - 130px);
    display: flex;
    flex-direction: column;
    .search-form {
      padding-left: 16px;
    }
    .flex-box {
      display: flex;
      justify-content: center;
      align-content: center;
    }
    .list-item-wrapper {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow-y: auto;
      .list-item {
        display: flex;
        cursor: pointer;
        flex-shrink: 0;
        align-items: center;
        height: 66px;
        .list-item-element {
          display: flex;
          flex: 1;
          align-items: center;
          height: 50px;
          padding: 0 16px;
          &:hover {
            background: #F7F7FF;
          }
        }
        .list-item-status {
          width: 48px;
          height: 18px;
          border-radius: 8px;
          font-size: 12px;
          text-align: center;
          background: #FFEEE9;
          color: #E55454;
          border: 1px solid #FFDBCF;
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            transform: scale(0.8);
            display: inline-block;
            width: fit-content;
          }
          &.expires {
            background: #F2F3F7;
            color: #999;
            border: 1px solid transparent;
          }
        }
        .list-item-content-wrapper {
          flex: 1;
          display: flex;
          margin-left: 8px;
          align-items: center;
          height: 66px;
          border-bottom: 0.5px solid rgba(96, 82, 246, 0.1);
        }
        .list-item-content {
          flex: 1;
          font-size: 14px;
          min-width: 0;
          padding: 0 8px 0 0;
          color: #113D38;
          font-weight: 600;
        }
        .list-item-time {
          font-size: 12px;
          color: #A09EBF;
        }
      }
    }
  }

  .el-tooltip {
    max-width: 80%;
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
/deep/ .header-left {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/home-notice/notice-drawer.vue